import { ReactComponent as Loader } from './divloader.svg';
import './buttonloader.css';

const DivLoader = ({style={backGroundColor:'transparent',fontSize:'medium',width:'70%'}, loading = false}) => {
    return (
      <div style={{background:style.backGroundColor,width:style.width,margin:'auto'}} className="submit-btn">
        <div style={{margin:'auto'}}>
          {!loading ? '' : <Loader className="spinner" />}
        </div>
      </div>
    )
  }
  
  export default DivLoader